import { render, staticRenderFns } from "./TourTabsDepartures.vue?vue&type=template&id=f48162a6&scoped=true&"
import script from "./TourTabsDepartures.vue?vue&type=script&lang=js&"
export * from "./TourTabsDepartures.vue?vue&type=script&lang=js&"
import style0 from "./TourTabsDepartures.vue?vue&type=style&index=0&id=f48162a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48162a6",
  null
  
)

export default component.exports